<template>
    <div>
        <card-header title="Rooming List" icon="fa-bed"/>

        <card-body>
            <card-list>
                <subheader-list-item icon="fa-sliders-h" title="Report options"/>
                <container-list-item padded>
                    <div class="columns">
                        <div class="column">
                            <b-field label="Hotel" label-position="inside">
                                <b-select v-model="hotelId" expanded>
                                    <option :value="null">All Hotels</option>
                                    <option :value="hotel.id" v-for="hotel in hotels">{{hotel.title}}</option>
                                </b-select>
                            </b-field>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-switch :true-value="1" :false-value="0" v-model="includeMissing">Include travelers without a hotel</b-switch>
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <b-switch :true-value="1" :false-value="0" v-model="includePassports">Include passport information</b-switch>
                        </div>
                    </div>
                    <div class="is-size-7 has-text-grey">
                        One row per guest, roommates grouped under a shared room number, with total
                        rooms and nights per hotel. Choose a single hotel to export a list you can
                        send to that hotel directly. Including travelers without a hotel appends a
                        row per traveler who has no hotel stay on the trip yet, marked
                        <strong>NO HOTEL</strong> with blank dates, so you can see who still needs
                        a room. Passport information adds each guest's passport number,
                        nationality, issue/expiry dates and issuing authority.
                    </div>
                </container-list-item>
            </card-list>
        </card-body>

        <card-footer class="pt-3 pb-3 has-text-right">
            <b-button type="is-primary" size="is-small" @click="generate"><i class="fas fa-file-download mr-2"></i>Generate Report</b-button>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    import {client as http, apiUrl} from '@/http_client';
    import {mapGetters} from "vuex";

    // Report options card: pick the filters, then generate. The download
    // itself is the same authenticated GET the other report links use.
    export default {
        props: ['card', 'props'],
        components: {ContainerListItem, SubheaderListItem, CardList, CardFooter, CardBody, CardHeader},
        data: function () {
            return {
                hotels: [],
                hotelId: null,
                // On by default: the gap is what staff pull this report to
                // find. Off when sending a single hotel its own list.
                includeMissing: 1,
                includePassports: 0,
                apiUrl
            };
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            loadHotels: function () {
                this.$emit('loading', true);
                http.get('/api/trips/' + this.props.tripId + '/hotels', {force: true}).then(response => {
                    this.hotels = response.data;
                    this.$emit('loading', false);
                });
            },
            generate() {
                let url = `${this.apiUrl}api/trips/${this.props.tripId}/reports/rooming?auth=${this.currentUser.token}`;
                if (this.hotelId) url += `&hotel=${this.hotelId}`;
                if (this.includeMissing) url += `&missing=1`;
                if (this.includePassports) url += `&passport=1`;
                window.open(url, '_blank');
            },
            reload: function () {
                this.loadHotels();
            }
        },
        watch: {
            'props.tripId': function () {
                this.loadHotels();
            }
        },
        mounted() {
            this.loadHotels();
        }
    };
</script>

<style lang="scss" scoped>

</style>
